module.exports = __webpack_public_path__ + "static/media/icon-mail.4ecaff92.svg";